var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"clearfix\"><div class=\"pull-left\" ng-transclude=\"left\"><h4 class=\"m-y-0\" ng-bind-html=\"$ctrl.left\"></h4></div><div class=\"pull-right text-right\" ng-transclude=\"right\"><span ng-bind-html=\"::$ctrl.right\"></span></div></div>";
var id1="heading.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;